(() => {
  const settings = document.currentScript?.dataset;
  if (!settings?.signupUrl || !settings.fallbackLabel || !settings.fallbackNote) return;
  const mount = (root) => {
    if (root.dataset.pavelsAvailabilityReady) return;
    const embed = root.querySelector('[class*="klaviyo-form-"]');
    if (!embed) return;
    root.dataset.pavelsAvailabilityReady = 'true';
    const panel = document.createElement('div');
    panel.className = 'pavels-newsletter-availability';
    panel.hidden = true;
    panel.setAttribute('aria-live', 'polite');
    const link = document.createElement('a');
    link.className = 'btn pavels-riviera-club__submit';
    link.href = settings.signupUrl;
    link.textContent = settings.fallbackLabel;
    const note = document.createElement('p');
    note.className = 'pavels-newsletter-availability__note';
    note.textContent = settings.fallbackNote;
    panel.append(link, note);
    embed.after(panel);
    let gracePeriodPassed = false;
    const update = () => {
      const nativeContent = embed.getBoundingClientRect().height > 0 &&
        (embed.innerText.trim().length > 0 ||
          Array.from(embed.querySelectorAll('input:not([type="hidden"]), button, iframe'))
            .some(element => element.getClientRects().length > 0));
      const hidePanel = !gracePeriodPassed || nativeContent;
      if (panel.hidden !== hidePanel) panel.hidden = hidePanel;
    };
    const observer = new MutationObserver(update);
    observer.observe(embed, {childList: true, subtree: true, attributes: true});
    window.addEventListener('resize', update);
    setTimeout(() => { gracePeriodPassed = true; update(); }, 6000);
  };
  const init = () => document.querySelectorAll('.pavels-newsletter-restored').forEach(mount);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true});
  else init();
  document.addEventListener('shopify:section:load', init);
})();
